import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Logo } from '../../components/logo/logo';

@Component({
  selector: 'app-forgot-password',
  imports: [CommonModule, ReactiveFormsModule, RouterLink, Logo],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.css',
})
export class ForgotPassword {
  private fb = inject(FormBuilder);
  private http = inject(HttpClient);

  forgotForm: FormGroup;
  isSubmitting = signal(false);
  showError = signal(false);
  errorMessage = signal('');
  showSuccess = signal(false);
  successMessage = signal('');

  constructor() {
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.forgotForm.invalid) {
      this.forgotForm.markAllAsTouched();
      return;
    }

    this.isSubmitting.set(true);
    this.showError.set(false);
    this.showSuccess.set(false);

    this.http.post<any>(`${environment.apiUrl}/forgot-password`, this.forgotForm.value).subscribe({
      next: (res) => {
        this.isSubmitting.set(false);
        if (res.status) {
          this.showSuccess.set(true);
          this.successMessage.set(res.message);
          this.forgotForm.reset();
        } else {
          this.showError.set(true);
          this.errorMessage.set(res.message || 'Something went wrong');
        }
      },
      error: () => {
        this.isSubmitting.set(false);
        this.showError.set(true);
        this.errorMessage.set('Something went wrong. Please try again.');
      },
    });
  }

  isFieldInvalid(field: string): boolean {
    const control = this.forgotForm.get(field);
    return !!(control && control.invalid && control.touched);
  }
}
